import { roleToHumanReadable } from "@/data/leaseData";
import * as _ from "lodash";
import { ALL_PROSPECTS_COLUMNS } from "./DefaultSettings";

export function getTimelineTitles(item) {
  if (item.isAggregate) {
    switch (item.type) {
      default:
        return "Inconnu";
    }
  } else {
    switch (item.type) {
      case "PROSPECT_CHANGEMENT_STATUT":
        return "Le statut du prospect a changé";
      case "PROSPECT_ROLE_CHANGE":
        return "Le prospect a été réassigné";
      default:
        return "Inconnu";
    }
  }
}

export function getTimelineLinks(item) {
  const getLink = item => {
    switch (item.type) {
      default:
        return null;
    }
  };
  if (item.isAggregate) {
    return item.paramsGroup.map(params => {
      return getLink({
        ...item,
        params
      });
    });
  } else {
    return [getLink(item)];
  }
}

export function getTimelineDescriptions(item) {
  switch (item.type) {
    case "PROSPECT_CHANGEMENT_STATUT":
      return `Il est désormais dans l'état : ${
        ALL_PROSPECTS_COLUMNS.filter(
          ({ value }) => value === item.params.progress
        )[0].text
      }`;
    case "PROSPECT_ROLE_CHANGE":
      return `Il est passé de ${item.params.from} à ${
        item.params.to
      } sur les rôles ${item.params.roles
        .map(role => roleToHumanReadable(role) || role)
        .join(", ")}`;
    default:
      return null;
  }
}

export function prospectLinkEnabled(prospect) {
  return (
    prospect.shortid &&
    _.findIndex(ALL_PROSPECTS_COLUMNS, {
      value: prospect.currentProgress
    }) >=
      _.findIndex(ALL_PROSPECTS_COLUMNS, {
        value: "pitched"
      })
  );
}

export function getValidationRulesFromProgress(progress) {
  const validationRulesPerStatus = {
    new: {
      name: "required"
    },
    toCall: {
      siret: "required",
      address: "required",
      employeesCount: "required",
      structureType: "required",
      type: "required",
      origin: "required",
      "assignees.sale": "required"
    },
    firstContact: {
      companyContactName: "required",
      companyContactPhone: "required",
      companyContactMail: "required",
      companyContactJob: "required"
    },
    pitched: { demoDate: "required" },
    involved: {
      actionsToDo: "required",
      aboutContacts: "required",
      aboutProcess: "required",
      aboutHousing: "required",
      potentialAltHiL: "required|numeric",
      potentialAltHiring: "required|numeric",
      potentialMutationHiL: "required|numeric",
      potentialMutationHiring: "required|numeric",
      potentialNewHiL: "required|numeric",
      potentialNewHiring: "required|numeric"
    }
  };

  let found = false; // We need to include validation for step+1 to get orange fields
  const rules = {};
  for (const { value } of ALL_PROSPECTS_COLUMNS) {
    const levelRules = validationRulesPerStatus[value];
    if (levelRules) {
      Object.assign(rules, levelRules);
    }

    if (found) {
      break;
    }

    if (value === progress) {
      found = true;
    }
  }
  return rules;
}

export function getInfoFields(prospect) {
  const rules = getValidationRulesFromProgress(prospect.currentProgress);

  return {
    infos: [
      {
        name: "name",
        label: "Nom",
        validation: rules["name"]
      },
      {
        name: "siret",
        label: "SIRET",
        validation: rules["siret"]
      },
      {
        name: "address",
        label: "Adresse",
        as: "geocomplete",
        onAddressChanged: data => (prospect.addressObject = data),
        addressIsValidAtBeginning: () => prospect.addressObject != null,
        validation: rules["address"]
      },
      {
        name: "employeesCount",
        label: "Nombre d'employés de la structure",
        as: "select",
        items: [
          { text: "-- CHOISIR --", value: "", disabled: true },
          { text: "10-50 salariés", value: "10-50" },
          { text: "50-250 salariés", value: "50-250" },
          { text: "250-1000 salariés", value: "250-1000" },
          { text: "1000-2500 salariés", value: "1000-2500" },
          { text: "2500+ salariés", value: "2500+" }
        ],
        validation: rules["employeesCount"]
      },
      {
        name: "structureType",
        label: "Structure",
        as: "select",
        allowOthers: true,
        items: [
          { text: "-- CHOISIR --", value: "", disabled: true },
          { text: "Siège", value: "siege" },
          { text: "Filiale", value: "filiale" },
          { text: "Bureau", value: "bureau" },
          { text: "Usine", value: "usine" },
          { text: "Franchise", value: "franchise" },
          { text: "Agence", value: "agence" },
          { text: "* Autres", value: "__" }
        ],
        validation: rules["structureType"]
      },
      {
        name: "type",
        label: "Typologie",
        as: "select",
        allowOthers: true,
        items: [
          { text: "-- CHOISIR --", value: "", disabled: true },
          { text: "Entreprise", value: "entreprise" },
          { text: "Ecole", value: "ecole" },
          { text: "Cabinet de recrutement", value: "recrutement" },
          { text: "CCI", value: "cci" },
          { text: "Collectivité", value: "collectivite" },
          { text: "* Autres", value: "__" }
        ],
        validation: rules["type"]
      },
      {
        name: "origin",
        label: "D'où vient cette cible ? ",
        as: "select",
        allowOthers: true,
        items: [
          { text: "-- CHOISIR --", value: "", disabled: true },
          { text: "LinkedIn", value: "linkedin" },
          { text: "Réseau perso.", value: "network_perso" },
          { text: "Réseau pro", value: "network_pro" },
          { text: "Jobboard (apec...)", value: "jobboard" },
          { text: "Démarchage direct", value: "direct" },
          { text: "* Autres", value: "__" }
        ],
        validation: rules["origin"]
      },
      {
        name: "assignees.sale",
        label: "Commercial",
        as: "staff",
        permission: "self",
        validation: rules["assignees.sale"]
      },
      {
        name: "techname",
        label: "Personnalisation du lien entreprise",
        show: () => prospectLinkEnabled(prospect)
      }
    ],
    potential: [
      {
        label: "",
        name: ["dummy1", "_dummy2"],
        hint: ["", ""],
        readOnly: true,
        value: [() => "Recrutement", () => "Potentiel HiL"],
        validation: ["", ""]
      },
      {
        label: "Alternant",
        name: ["potentialAltHiring", "potentialAltHiL"],
        hint: ["Recrutement", "Potentiel HiL"],
        validation: [rules["potentialAltHiring"], rules["potentialAltHiL"]]
      },
      {
        label: "Mutation",
        name: ["potentialMutationHiring", "potentialMutationHiL"],
        hint: ["Recrutement", "Potentiel HiL"],
        validation: [
          rules["potentialMutationHiring"],
          rules["potentialMutationHiL"]
        ]
      },
      {
        label: "Nouveaux embauchés",
        name: ["potentialNewHiring", "potentialNewHiL"],
        hint: ["Recrutement", "Potentiel HiL"],
        validation: [rules["potentialNewHiring"], rules["potentialNewHiL"]]
      }
    ],
    contact: [
      {
        name: "companyContactName",
        label: "Nom du contact",
        validation: rules["companyContactName"]
      },
      {
        name: "companyContactPhone",
        label: "Téléphone",
        validation: rules["companyContactPhone"]
      },
      {
        name: "companyContactMail",
        label: "Mail",
        validation: rules["companyContactMail"]
      },
      {
        name: "companyContactJob",
        label: "Poste",
        validation: rules["companyContactJob"]
      }
    ]
  };
}

export const notInterestedCauses = [
  { value: "otherService", text: "A déjà un autre prestataire" },
  { value: "priority", text: "Pas dans ses priorités" },
  { value: "uneligible", text: "Structure non éligible" },
  { value: "other", text: "Autre..." }
];
